<template>
    <div v-if="show">
      <hp5-alert type="info" hide-alert-text :show-alert="true">
        <span class="bold">Coverage</span
        ><span
          >You are viewing dentists in the Pediatric Dental Network. This network is only available to children under 19 covered under your plan.</span
        >
      </hp5-alert>
    </div>
</template>
  
<script setup>

      const { searchResults, plan } = useFCPModel()
      const restrictions = ref(plan.value ? plan.value.restrictions : '')
  
      const show = computed(() => restrictions.value == 'pediatric-dental')
  
      //Watch for changes in searchResults and then set the internal restrictions variable with
      //the current value on the plan.  Only do this after search so that changing the plan, for example,
      //by changing the value in the network filter will not cause the alert to display immediately.
      watch(searchResults, () => {
        restrictions.value = plan.value.restrictions
      })
  
</script>
  
<style scoped>
  .bold {
    font-weight: bold;
  }
</style>